import { render, staticRenderFns } from "./order_tbd_detail.vue?vue&type=template&id=7f20554d&scoped=true&"
import script from "./order_tbd_detail.vue?vue&type=script&lang=js&"
export * from "./order_tbd_detail.vue?vue&type=script&lang=js&"
import style0 from "./order_tbd_detail.vue?vue&type=style&index=0&id=7f20554d&prod&lang=scss&scoped=true&"
import style1 from "./order_tbd_detail.vue?vue&type=style&index=1&id=7f20554d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f20554d",
  null
  
)

export default component.exports